import React from 'react';

/**
 * WHAT A SLOT CARRIES BESIDE THE NAME — one reading for every bracket that
 * draws results (the «Поєдинки» and «Жеребкування» tabs, 26 Oct 2026): a
 * score-judged round's score, DNS, or an MSAC bout's penalty points with how
 * the winner won.
 *
 * @param {Array} results the category's rows
 * @param {Function} t the translator
 * @return {Object} { [resultId]: node }
 */
export const bracketSlotAnnotations = (results, t) => {
    // Score-judged rounds show the entered score right in the tree.
    // …and an MSAC bout shows each side's penalty points (21 Oct 2026: «ці
    // бали необхідно показувати в кожному поєдинку»), for a decided bout only.
    const slotAnnotations = {};
    results.forEach(row => {
        if (row.score !== null && row.score !== undefined) {
            slotAnnotations[row.id] = String(row.score);
        } else if (row.dns) {
            slotAnnotations[row.id] = t('workspace.scoreRound.dns', 'DNS');
        } else if (null !== row.win && undefined !== row.win && null !== row.penaltyPoints && undefined !== row.penaltyPoints) {
            // HOW IT WAS WON beside the winner's points (25 Oct 2026: «щоб теж
            // був напис») — the rulebook's abbreviation, the words on hover.
            slotAnnotations[row.id] = true === row.win && row.victoryClass ? (
                <span title={t(`workspace.matches.victoryClass.${row.victoryClass}`)} data-testid='bracket-victory-class'>
                    {`${row.penaltyPoints} · ${t(`workspace.matches.victoryClassShort.${row.victoryClass}`)}`}
                </span>
            ) : String(row.penaltyPoints);
        }
    });

    return slotAnnotations;
};

export default bracketSlotAnnotations;
